module.exports = __webpack_public_path__ + "static/media/bikedelivery.063f30cb.svg";